<template lang='pug'>
  v-flex(class="white--text xs12 sm6 offset-sm3")
    div
      img.mx-2( :src="companyIcon")
</template>

<script>
  export default {
    name: 'main-banner',
    data () {
      return {
        companyIcon: require('@/assets/oncallair_logo.svg'),
      }
    }
  }
</script>

<style scoped lang="scss">

  img{
    padding-top: 25%
  }

</style>
